import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="bulk-selection"
export default class extends Controller {
  static targets = ["checkbox", "selectAll", "selectedCount", "selectedIds", "deleteButton"]
  
  connect() {
    console.log("Bulk selection controller connected")
    console.log(`Found ${this.checkboxTargets.length} checkboxes`)
    console.log(`Found selectAll: ${this.hasSelectAllTarget}`)
    console.log(`Found selectedCount: ${this.hasSelectedCountTarget}`)
    console.log(`Found selectedIds: ${this.hasSelectedIdsTarget}`)
    console.log(`Found deleteButton: ${this.hasDeleteButtonTarget}`)
    this.updateUI()
    
    // Add event listeners directly
    this.selectAllTarget.addEventListener('change', this.handleSelectAllChange.bind(this))
    this.checkboxTargets.forEach(checkbox => {
      checkbox.addEventListener('change', this.handleCheckboxChange.bind(this))
    })
    this.deleteButtonTarget.addEventListener('click', this.handleDeleteButtonClick.bind(this))
  }
  
  handleSelectAllChange(event) {
    console.log("Select all changed")
    const checked = event.target.checked
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = checked
    })
    this.updateUI()
  }
  
  handleCheckboxChange() {
    console.log("Checkbox changed")
    // If any checkbox is unchecked, uncheck the "select all" checkbox
    if (this.checkboxTargets.some(checkbox => !checkbox.checked)) {
      this.selectAllTarget.checked = false
    } 
    // If all checkboxes are checked, check the "select all" checkbox
    else if (this.checkboxTargets.every(checkbox => checkbox.checked)) {
      this.selectAllTarget.checked = true
    }
    
    this.updateUI()
  }
  
  handleDeleteButtonClick(event) {
    console.log("Delete button clicked")
    const selectedCount = this.checkboxTargets.filter(checkbox => checkbox.checked).length
    
    if (!confirm(`Are you sure you want to delete ${selectedCount} selected customers? This action cannot be undone.`)) {
      event.preventDefault()
    }
  }
  
  updateUI() {
    const selectedCount = this.checkboxTargets.filter(checkbox => checkbox.checked).length
    console.log(`Selected count: ${selectedCount}`)
    
    // Update selected count
    this.selectedCountTarget.textContent = selectedCount
    
    // Enable/disable delete button
    if (selectedCount > 0) {
      console.log("Enabling delete button")
      this.deleteButtonTarget.disabled = false
    } else {
      console.log("Disabling delete button")
      this.deleteButtonTarget.disabled = true
    }
    
    // Update hidden input with selected IDs
    const selectedIds = this.checkboxTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value)
      .join(',')
    
    console.log(`Selected IDs: ${selectedIds}`)
    this.selectedIdsTarget.value = selectedIds
  }
}
